module.exports = __webpack_public_path__ + "img/campus-hohe-effizienz.b973c524.svg";